export default "__VITE_ASSET__Cyd58zuQ__";